import React, { useState, useEffect } from 'react';
import ChartOpinionOnValuation from './ChartOpinionOnValuation';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChart2Data(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChart2Data(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartOpinionOnValuationData = () => {
  const [dataSet, setDataSet] = useState('d1');
  const [data, loading, error] = useData(dataSet);

  // const handleChangeDataSet = () => {
  //   setDataSet(dataSet === 'd1' ? 'd2' : 'd1');
  //   console.log(dataSet);
  //   console.log(data);
  // };

  return (
    <>
      <ChartOpinionOnValuation data={data} error={error} loading={loading} />
    </>
  );
};

export default ChartOpinionOnValuationData;
